<template>
    <p class="p5">
        <slot />
    </p>
</template>
